module.exports = __webpack_public_path__ + "img/dynamicFuzzy.86a505d1.gif";